<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	<el-form :inline="true" class="demo-form-inline backborder1" ref="search" :model="search" size="small">
		    <el-form-item>
	    		<el-select v-model="create.supplierid" clearable filterable remote reserve-keyword placeholder="请选择供应商" @change="changesupplier">
			        <el-option v-for="(item,index) in supplierlists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
			    </el-select> 
		    </el-form-item>
		    <el-form-item>
	    		<el-input placeholder="请输入条形码" v-model="codekey" style="width:100%" @keyup.enter.native="searchgoodsfromcode">
		          	<template slot="prepend">查找</template>
		          	<el-button slot="append" icon="el-icon-search" @click="searchgoodsfrombutton"></el-button>
		        </el-input>
		    </el-form-item>
		    <el-form-item>
		    	<el-button type="warning" icon="el-icon-search" @click="addproducts">添加采购商品</el-button>
		    </el-form-item>
			<el-form-item>
		    	<el-tooltip class="item" effect="dark" content="可对下面的商品列表进行拖拽排序" placement="top">
		    		<el-button :type="sorttype" :icon="sorticon" @click="startandstopsort">{{sortname}}</el-button>
		    	</el-tooltip>
		    </el-form-item>	    	      
			<el-form-item>
				<el-badge :value="create.goods.length > 0 ? create.goods.length : ''" class="item">
		    	<el-button type="" icon="el-icon-delete" @click="clearselectgoods">清空采购商品</el-button>
				</el-badge>
		    </el-form-item>	    	      	    	      
        </el-form>


		<div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
			<div class="cz-sell-base-lists-infos-out">
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">单据编号</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
					</div>
				</div>
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">仓库</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-select v-model="create.warehouse_id" placeholder="请选择仓库">
							<el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
						</el-select> 
					</div>
				</div>
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">采购人员</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-select v-model="create.clerkid" clearable filterable remote reserve-keyword placeholder="请选择采购人员" @change="setseller">
							<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
						</el-select> 
					</div>
				</div>
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">订单备注</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-input placeholder="请填写订单备注" v-model="create.desc" @blur="setdesc" />
					</div>
				</div>
			</div>

			<div class="cz-sell-base-lists-infos-goods" style="margin-top:10px" v-if="sorttable==true">
			<el-table :data="create.goods" border="1" show-summary :summary-method="totalRule" style="width: 100%" v-loading="goodsListLoading">   
				<el-table-column label="序号" prop="sort" min-width="100" align="center">
					<template slot-scope="props">
						<div style="font-size:13px">{{props.row.sort}}</div>
					</template>
				</el-table-column> 		    	
	        	<el-table-column label="商品名称" prop="name" min-width="250">
					<template slot-scope="props">
						<div style="font-size:13px">{{props.row.name}}</div>
						<div style="font-size:12px;color:#999999">编号：{{props.row.number}}</div>
					</template>
				</el-table-column>
	        	<el-table-column label="单位" prop="unit" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].unit"  @focus="getUnitlists(props.row.productid,props.row.id,props.row.unitid)"></el-input>
	        		</template>
	        	</el-table-column>
				<el-table-column label="单价" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].price"  @blur="setgoodsprice(props.row.id,props.row.price)"></el-input>
	        		</template>
	        	</el-table-column>
				<el-table-column label="折扣（100%）" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].discount"  @blur="setgoodsdiscount(props.row.id,props.row.discount)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="折后单价" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].sell"  @blur="setgoodssell(props.row.id,props.row.sell)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="数量" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].num"  @blur="setgoodsnum(props.row.id,props.row.num)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="小计" min-width="110" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].total"  @blur="setgoodstotal(props.row.id,props.row.total)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="操作" min-width="120" align="center" fixed="right">
	        		<template slot-scope="props">
	        			<el-button type="warning" size="small" round  @click="copygoods(props.row.id)">复制</el-button>
	        			<el-button type="" size="small" round  @click="delgoods(props.row.id)">删除</el-button>
	        		</template>
	        	</el-table-column>	        
      		</el-table>
			</div>

			<div style="background:#fff;width:98%;float:left;margin-top:10px;padding:1% 1% 1% 1%;border-radius:5px;border:1px solid #ccc" v-if="sorttable==false">
			<draggable :list="listsorts" :move="getdata" @update="datadragEnd" :options="{animation: 200,handle:'.dargDiv'}" >
				<transition-group name="list-complete">
			    	<div class="dargDiv" v-for="(item,index) in listsorts" :key="index" style="float:left;font-size:14px;width:100%;border-bottom:1px dashed #dddddd;">
			      		<span style="float:left;width:7%;padding:15px 0 15px 1%">{{item.number}}</span>
			      	    <span style="float:left;width:24%;padding:15px 0 15px 2%">{{item.name}}</span>
			      	    <span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.spec}}</span>
			      	    <span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.unit}}</span>
						<span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.num}}</span>
						<span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.price}}</span>
						<span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.discount}}</span>
			      	    <span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.sell}}</span>
			      	    <span style="float:left;width:7%;padding:15px 0 15px 2%">{{item.total}}</span>
			      	</div>			      	         		
			    </transition-group>
			</draggable>
			</div>

			<div class="cz-sell-order-stat">
				<div class="cz-sell-order-stat-totals" style="width:calc(100% - 10% - 40px - 40px - 1px)">
					<div style="float:left;width:100%">
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">合计金额：￥</span>
							<span class="cz-sell-order-stat-totals-name-content">{{create.total}}</span>
						</div>
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">优惠金额：￥</span>
							<el-input placeholder="优惠金额" v-model="create.derate" @blur="setderate" />
						</div>
						<div class="cz-sell-order-stat-totals-name" style="width:calc(33% - 30px) !important">
							<span class="cz-sell-order-stat-totals-name-title">实付金额：￥</span>
							<el-input placeholder="实付金额" v-model="create.deals" @blur="setdeal" />
						</div>
					</div>
					<div class="cz-sell-order-stat-handles" style="width:45%">
						<el-button size="small" type="warning" @click="saveorder" :loading="saveorderLoading">保存订单</el-button>
			    		<el-button size="small" type="warning" @click="verifyorder" :loading="verifyorderLoading" v-if="create.isdraft==1 && actionauth.cg_order_verify=='true'">审核订单</el-button>
			    		<el-button size="small" type="warning" @click="verifyandprintorder" :loading="verifyandprintLoading" v-if="create.isdraft==1 && actionauth.cg_order_verify=='true'">审核并打印订单</el-button>
						<el-button size="small" type=""  @click="delorder" :loading="delorderLoading" v-if="create.id>0 && create.status==0 && actionauth.cg_order_del=='true'">删除订单</el-button>
					</div>
				</div>
			</div>

		</div>


		
		<!--------- 采购商品信息列表 ------------>
    	<el-dialog title="添加采购商品信息" :visible.sync="addgoodsDialog" width="60%" top="5vh"> 
    		<el-form :inline="true" class="demo-form-inline" size="small">
	      	    <el-form-item>
	                <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="changebrand">
	              	    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
	              	    	<span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
	              	    </el-option>
	                </el-select>
	            </el-form-item>
	            <el-form-item>
	                <el-cascader :options="categorylist" v-model="productquery.catid" clearable @change="changecate"></el-cascader>
	            </el-form-item>
	            <el-form-item>
	                <el-input placeholder="商品名称 / 编号 / 拼音码 / 条形码" v-model="productquery.key" clearable @keyup.enter.native="getProductList" @change="selectproduct=true" @input="changesearchkey"></el-input>
	            </el-form-item>
	            <el-form-item>
	                <el-button type="warning" icon="el-icon-search" @click="getProductList">查询</el-button>
	            </el-form-item>
      	    </el-form>
      	    <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-click="rowclick" @select="handleSelectsingle" @select-all="handleSelectionChange">
	            <el-table-column type="selection" width="50"></el-table-column>
				<el-table-column prop="id" label="ID" width="100" align="center">
					<template slot-scope="scope">
						<div class="purchase-goods-id">{{scope.row.id}}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" min-width="250">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.name}}</div>
						<div style="font-size:12px;color:#999999">编号：{{scope.row.number}}</div>
					</template>
				</el-table-column>
				<el-table-column label="条形码" min-width="150" align="center">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.basebarcode && scope.row.basebarcode!=='' ? scope.row.basebarcode : '-'}}</div>
					</template>
				</el-table-column>
	            <el-table-column prop="showsell" label="批发价" min-width="150" align="center">
					<template slot-scope="scope">
						<div style="font-size:13px">{{scope.row.showsell}}</div>
					</template>
				</el-table-column>
	        </el-table>
	        <div class="block">
        	<!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="product_order_rows">
            </el-pagination>
            <!--分页end-->
      		</div>
      		<div slot="footer" class="dialog-footer">
      			<el-button size="small" @click="addgoodsDialog=false">取 消</el-button>
      			<el-button size="small" type="warning" @click="addgoods">保存</el-button>
      		</div>      	
    	</el-dialog>
    	
    	<!-------------获取单位信息列表--------------->
    	<el-dialog title="单位信息" :visible.sync="unitDialog" width="35%" top="5vh">
    		<el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
	            <el-table-column prop="unit" label="单位"></el-table-column>
	            <el-table-column prop="buy" label="采购价" align="center"></el-table-column>
	            <el-table-column label="操作" align="center">
	            	<template slot-scope="props">
	            		<el-button type="success" icon="el-icon-check" size="small" circle @click="saveunitid(props.row.id)"></el-button>
	            	</template>
	            </el-table-column>
	        </el-table>
    	</el-dialog>
    	
    	<!---------------- 获取生成进货入库商品信息 -------------->
    	<el-dialog title="生成进货入库单信息" :visible.sync="inputDialog" width="85%" top="5vh">
    		<el-tag type="danger">温馨提示：没有入库的商品请将入库数量设置为 0</el-tag>
    		<el-table :data="inputlists" style="width:100%;margin-top:15px" v-loading="inputLoading">
	            <el-table-column prop="number" label="编号" width="100"></el-table-column>
	            <el-table-column prop="name" label="商品"></el-table-column>
	            <el-table-column prop="spec" label="规格" align="center" width="100"></el-table-column>
	            <el-table-column prop="sell" label="单价" align="center" width="120"></el-table-column>
	            <el-table-column prop="unit" label="单位" align="center" width="100"></el-table-column>
	            <el-table-column prop="num" label="数量" align="center" width="100"></el-table-column>
	            <el-table-column prop="total" label="小计" align="center" width="100"></el-table-column>
	            <el-table-column label="入库数量" align="center" width="100">
	            	<template slot-scope="props">
	            		<el-input size="medium" type="input" v-model="props.row.paynum"  @blur="changenum(props.$index,props.row)"></el-input>
	            	</template>
	            </el-table-column>
	            <el-table-column prop="paytotal" label="入库小计" align="center" width="100"></el-table-column>
	        </el-table>
	        <div slot="footer" class="dialog-footer">
      			<el-button size="medium" @click="inputDialog=false">取 消</el-button>
      			<el-button size="medium" type="primary" @click="savestorage">确定</el-button>
      		</div>   
    	</el-dialog>
    	
    	<!---------------- 获取采购单生成的进货入库订单记录 -------------->
    	<el-dialog title="采购单商品入库信息记录" :visible.sync="purchasecreateDialog" width="65%" top="5vh">
    		<el-table :data="purchasecreatelog" style="width:100%;margin-top:15px" v-loading="purchasecreateLoading">
	            <el-table-column type="expand">
		    		<template slot-scope="props">
			    		<el-table :data="props.row.goods">
			    			<el-table-column prop="number" label="编号" width="100"></el-table-column>
				            <el-table-column prop="name" label="商品"></el-table-column>
				            <el-table-column prop="spec" label="规格" width="80" align="center"></el-table-column>
				            <el-table-column prop="num" label="数量" width="80" align="center"></el-table-column>
				            <el-table-column prop="total" label="小计" width="80" align="center"></el-table-column>
				            <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
				            <el-table-column label="状态" width="120" align="center">
				            	<template slot-scope="grops">
				            		<el-tag type="danger" v-if="grops.row.status==0">{{grops.row.statusname}}</el-tag>
				            		<el-tag type="warning" v-if="grops.row.status==1">{{grops.row.statusname}}</el-tag>
				            		<el-tag type="success" v-if="grops.row.status==2">{{grops.row.statusname}}</el-tag>
				            		<el-tag type="info" v-if="grops.row.status==3">{{grops.row.statusname}}</el-tag>
				            		<el-tag type="info" v-if="grops.row.status==4">{{grops.row.statusname}}</el-tag>
				            	</template>
				            </el-table-column>
			            </el-table>
		            </template>
	    		</el-table-column>
	            <el-table-column prop="documents" label="进货单号"></el-table-column>
	            <el-table-column prop="total" label="总金额" width="100" align="center"></el-table-column>
	            <el-table-column prop="inputtime" label="生成日期" width="160" align="center"></el-table-column>
	            <el-table-column label="状态" width="120" align="center">
	            	<template slot-scope="props">
	            		<el-tag type="danger" v-if="props.row.status==0">{{props.row.statusname}}</el-tag>
	            		<el-tag type="warning" v-if="props.row.status==1">{{props.row.statusname}}</el-tag>
	            		<el-tag type="success" v-if="props.row.status==2">{{props.row.statusname}}</el-tag>
	            		<el-tag type="info" v-if="props.row.status==3">{{props.row.statusname}}</el-tag>
	            		<el-tag type="info" v-if="props.row.status==4">{{props.row.statusname}}</el-tag>
	            	</template>
	            </el-table-column>
	        </el-table>
    	</el-dialog>
    	
    	<!----------- 订单打印页面 ----------------> 
	    <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
  	  		<div style="width:100%;text-align:right">每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue(printlists[0].id)"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条</div>	
      			<div id="printContent" v-loading="printLoading">
          	  		<div v-for="(item,index) in printlists" :key="index">
          	  			<span style="float:right">{{item.pagesize}}</span>
	      	  			<DIV style="font-size:18px;padding-bottom:2px;margin-bottom:0" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>        
	      	  			<ul class="titlelists">
					  	    <li v-if="printsmodel.apply_name==1">供货商名：{{item.applyname}}</li>
						    <li v-if="printsmodel.documents==1">单据编号：{{item.documents}}</li>
						    <li v-if="printsmodel.phone==1">联系电话：{{item.phone}}</li>
						    <li v-if="printsmodel.clerkname==1">采购人员：{{item.clerkname}}</li>
						    <li v-if="printsmodel.desc==1">出库备注：{{item.desc}}</li>
						    <li v-if="printsmodel.address==1" style="width:100%">联系地址：{{item.address}}</li>
				  	  	</ul>
	      			
	          			<TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
			 			    <TR class="contactcontent">
			 			    	<TD><DIV align=center><b>序号</b></DIV></TD>
				            	<TD v-if="printsmodel.number==1"><DIV align=center><b>编号</b></DIV></TD>
				                <TD v-if="printsmodel.name==1"><DIV align=center><b>商品</b></DIV></TD>
				                <TD v-if="printsmodel.spec==1"><DIV align=center><b>规格</b></DIV></TD>
				                <TD v-if="printsmodel.unit==1"><DIV align=center><b>单位</b></DIV></TD>
				                <TD v-if="printsmodel.num==1"><DIV align=center><b>数量</b></DIV></TD>
								<TD v-if="printsmodel.sell==1"><DIV align=center><b>单价</b></DIV></TD>
								<TD v-if="printsmodel.discount==1"><DIV align=center><b>折扣</b></DIV></TD>
								<TD v-if="printsmodel.dis_sell==1"><DIV align=center><b>折后单价</b></DIV></TD>
				                <TD v-if="printsmodel.total==1"><DIV align=center><b>小计</b></DIV></TD>
			                </TR>
				            <tr v-for="(tt,ii) in item.goods" :key="ii"  class="contactcontent">
				            	<TD v-text="tt.gsort" align="center"></TD>
					            <TD v-if="printsmodel.number==1" v-text="tt.number" align="center"></TD>
					            <TD v-if="printsmodel.name==1" v-text="tt.name" style="padding-left:1%" ></TD>
					            <TD v-if="printsmodel.spec==1" v-text="tt.spec" style="padding-left:1%" ></TD>
					            <TD v-if="printsmodel.unit==1" v-text="tt.unit" align="center" ></TD>
					            <TD v-if="printsmodel.num==1" v-text="tt.num" align="center" ></TD>
								<TD v-if="printsmodel.sell==1" v-text="tt.price" align="center" ></TD>
								<TD v-if="printsmodel.discount==1" v-text="tt.discount" align="center" ></TD>
								<TD v-if="printsmodel.dis_sell==1" v-text="tt.sell" align="center" ></TD>
					            <TD v-if="printsmodel.total==1" v-text="tt.total" align="center" ></TD>
				            </tr>
				            <tr v-if="index+1==printlists.length" class="contactcontent">
					            <TD align="center">合计</TD>
					            <TD v-if="printsmodel.number==1" style="padding-left:1%" ></TD>
					            <TD v-if="printsmodel.name==1" style="padding-left:1%" ></TD>
					            <TD v-if="printsmodel.spec==1" style="padding-left:1%" ></TD>
					            <TD v-if="printsmodel.unit==1" align="center" ></TD>
					            <TD v-if="printsmodel.num==1" align="center" >{{item.goodscount}}</TD>
								<TD v-if="printsmodel.sell==1" align="center" ></TD>
								<TD v-if="printsmodel.discount==1" align="center" ></TD>
					            <TD v-if="printsmodel.dis_sell==1" align="center" ></TD>
					            <TD v-if="printsmodel.total==1" align="center" >{{item.total}}</TD>
				            </tr>
	      	  			</table>
	          			<TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
		          			<TBODY>
			          			<TR class="top1">
			          				<TD v-if="printsmodel.inputtime==1"><span>录单日期：{{item.inputtime}}</span></TD>
				          			<TD v-if="printsmodel.verifyer==1"><span>审核人：{{item.verifyername}}</span></TD>
				          			<TD v-if="printsmodel.manager==1"><span>操作人：{{item.managername}}</span></TD>
			          			</TR>
			          			<TR class="top1">				          			
				          			<TD v-if="printsmodel.alltotal==1"><span>合计金额：{{item.total}} 元</span></TD>
				          			<TD v-if="printsmodel.derate==1"><span>优惠金额：{{item.derate}} 元</span></TD>				          			
			          				<TD v-if="printsmodel.deals==1"><span>实付金额：{{item.deals}} 元</span></TD>
			          			</TR>
		          			</TBODY>
	          			</TABLE>
	          			<div class="pageBreak"></div>
          			</div>          
	  			</div>
		      	<div slot="footer" class="dialog-footer">
			        <el-button size="small" @click="printerDialog = false">取 消</el-button>			        
			        <el-button size="small" type="primary" icon="el-icon-printer" @click="createnoSave" :loading="printorderLoading">打印订单</el-button>
		      	</div>
  		</el-dialog>
	    <!----------- 订单打印页面 ---------------->      		
	
    </div>
 	</transition>       
</template>

<script>

/* 导入拖拽组件 */
import draggable from 'vuedraggable'
export default {
	props:['childdata'],
	components: {draggable},
    data () {
	    return {
	        url:this.GLOBAL.domain+"Purchase/index",
	        transitionshow:true,
	        actionauth:[],
	        create: {
	        	act:'saveorder',
	        	token:this.$cookies.get('token'),
	        	id:0,
	        	documents:'',
	        	clerkid:'',
	        	total:0.00,
	        	derate:0.00,
	        	deal:'',
	        	managerid:'',
	        	supplierid:'',
	        	desc:'',
	        	status:0,
	        	isdraft:1,
	        	type:'',
	        	goods:[],	
				warehouse_id:'',        	
	        },
	        selectproductids:[],
	        sorttable:false,
	        sorttype:'warning',
	        sorticon:'el-icon-circle-check-outline',
	        sortname:'启用排序',
	        listsorts:[],
	        goodsListLoading:false,
	        codekey:'',
	        listsorts:[],
	        supplierlists:[],
	        brandlists:[],
	        categorylist:[],
	        sellerLists:[],
	        saveorderLoading:false,
	        delorderLoading:false,
	        verifyorderLoading:false,
	        verifyandprintLoading:false,
	        selectproductids:[],
	        productquery: {
	        	act:'inventory',
	        	token:this.$cookies.get('token'),
	        	brandid:'',
	        	catid:[],
	        	supplierid:'',
	        	key:'',
	        	p:1,
	        	rollpage:10
	        },
	        addgoodsDialog:false,
	        addListLoading:false,
	        productlists:[],
	        product_order_rows:0,
	        selectproduct:false,
	        multipleTable:[],
	        changegoodsid:'',
	        changeunitid:'',
	        unitDialog:false,
	        unitListLoading:false,
	        unitlists:[],
	        printLoading:false,
	        printerDialog:false,
	        printlists:[],
	        orderstatus:'',
	        printsmodel:[],
	        rollpage:10,
	        printorderid:'',
			wareHouseLists:[]
	    }
    },
	
	watch: {
		childdata(val) {
			if(val.isreshpurchaseadd==2) { //已打开窗口，再次点击传递更新数据
				this.addOrder();
			}
		}
  	},

    mounted(){
    	this.getactionauth(); //获取权限设置
		this.getSeller();
    	this.getSupplier();
    	this.getBrand();
    	this.getCategoryList();
		var _this=this;
		setTimeout(function() {
			_this.addOrder();
			_this.getprintsmodel(); 
		},200);
		this.getWarehouse()
    },
  
    methods:{ 
	    /** 重置表单 **/
	    reset() {
	        this.$refs.create.resetFields();
	    },
	    
	    /** 获取操作功能权限 **/
  	    getactionauth() {
    	    var data =this.$cookies.get('actionauth');
    	    data=JSON.parse(data);
            this.actionauth=data;
        },
        
        //初始化加载重置订单信息
        addOrder() {
        	this.create.id=0;
	        this.create.documents='';
	        this.create.total=0.00;
	        this.create.derate=0.00;
	        this.create.deal=0.00;
	        this.create.managerid='';
	        this.create.supplierid='';
	        this.create.desc='';
	        this.create.status=0;
	        this.create.isdraft='';
	        this.create.goods=[];	        	
	    	this.addDialog=true;
	    	this.selectproductids=[];
	    	this.create.clerkid='';
			this.create.warehouse_id=''
	    	
	    	this.sorttable=true;
	    	this.sorttype='warning';
	    	this.sorticon='el-icon-circle-check-outline';
	    	this.sortname='启用排序';	    	
	    	this.getsingleorder(1);
        },
        
        /** 获取单个订单信息 **/
	    getsingleorder(type) {
	    	this.goodsListLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.query({act:'getorderinfo',token:this.$cookies.get('token'),type:type}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.goodsListLoading=false;
		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
				    this.create.documents=result.documents;
				    this.create.total=result.total;
				    this.create.derate=result.derate;
				    this.create.deals=result.deals;
				    this.create.managerid=result.managerid==0 ? '' : result.managerid;
				    this.create.supplierid=result.supplierid==0 ? '' : result.supplierid;
				    this.create.desc=result.desc;
				    this.create.status=result.status;
				    this.create.clerkid=result.clerkid;
				    this.create.isdraft=result.isdraft;
				    this.create.type=result.type;
					// this.create.warehouse_id=result.warehouse_id
				    if(this.create.clerkid==0 && this.sellerLists.length==0) this.create.clerkid='';

					//采购人员加载逻辑
					//1、如原来已选有采购员则用原来的采购员
					//2、原来没有选择采购员时，如果当前登录人员绑定有采购员则有已绑定的采购员
					//3、原来没有选择采购员、系统又没有绑定采购员则默认取第一个采购员
				    if((this.create.clerkid==0 || this.create.clerkid=='' || !this.create.clerkid) && this.sellerLists.length > 0) {
						let _this=this;
						this.sellerLists.forEach(function(item,i) {
							if(i==0) _this.create.clerkid=item.id;
							if(item.isdefault_purcharse==1) {
								_this.create.clerkid=item.id;
								return false;
							}
						});
					}
				    this.create.goods=result.goods;
				    
				    var _this=this;
					var sort=0;
				    this.listsorts=[];
				    this.create.goods.forEach(function(e,index) {
						sort++;
						e.sort=sort; //设置序号
				    	_this.listsorts.push({id:e.id,number:e.number,name:e.name,spec:e.spec,unit:e.unit,num:e.num,price:e.price,discount:e.discount,sell:e.sell,total:e.total});
				    });	   
		            this.goodsListLoading=false;                      
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.goodsListLoading=false;
	        });
	    },
	    
	    /** 获取销售员 **/
	    getSeller(){
	        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));	                      
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    /** 获取供应商信息 **/
	    getSupplier() {
	    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	        resource.query({act:'getapplyAll',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.supplierlists = JSON.parse(Base64.decode(res.data.Data));	                      
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    /** 获取品牌 **/
    	getBrand(){
	        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	          	this.$message.error(this.GLOBAL.errortext);
	        });
    	},
    	
    	/** 获取产品分类 **/
	    getCategoryList() {
	    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		          this.categorylist=JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    /** 启用/停止排序 **/
	    startandstopsort() {
	    	if(this.sorttable==true) {
	    		this.sorttable=false;
	    		this.sorttype='';
	    		this.sorticon='el-icon-circle-close-outline';
	    		this.sortname='停止排序';  
	    	}else {
	    		this.sorttable=true;
	    		this.sorttype='warning';
	    		this.sorticon='el-icon-circle-check-outline';
	    		this.sortname='启用排序';
	    		var result=[];
	    		var count=this.listsorts.length;
	    		this.listsorts.forEach(function(e,index) {
	    			count--;
	    			result.push({id:e.id,sort:count});
	    		});
	    		
	    		var resource = this.$resource(this.url);
	            resource.save({ act:'changesort',token:this.$cookies.get('token'),sortlists:result}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('采购商品排序编辑成功！');
	                    this.getsingleorder(this.create.type);
	                }
	            }).catch((res) => {
	            	
	            });
	    		 
	    	}
	    },
	    
	    /** 修改供应商 **/
	    changesupplier() {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setsupplier',type:this.create.type,supplierid:this.create.supplierid,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    //条形码搜索商品
	    searchgoodsfromcode() {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
	    	
	    	//重置搜索条件
	    	this.productquery.brandid='';
	    	this.productquery.catid=[];
	    	this.productquery.supplierid=this.create.supplierid;
	    	this.productquery.key='';
	    	this.productquery.p=1;
	    	this.productquery.rollpage=10;
	    	this.selectproductids=[];
	    	
	    	//检测商品是否只有一个，如果有则直接添加进入购物车，如果有多个则展开列表
	    	var resource = this.$resource(this.url);
	        resource.save({act:'checkgoodsnums',token:this.$cookies.get('token'),code:this.codekey,supplierid:this.create.supplierid}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.codekey='';
		        }else{
		            var result=JSON.parse(Base64.decode(res.data.Data));
		            if(result.count==0) {
		            	this.codekey='';
		            	this.$message.error("该商品信息不存在");
		            }else if(result.count==1) {
		            	this.codekey='';
		            	this.selectproductids.push(result.productid);
		            	this.addgoods();			            	
		            }else {
		            	this.productquery.key=this.codekey;
		            	this.codekey='';
		            	this.addgoodsDialog=true;
		            	this.getProductList();	            	 
		            }
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    /** 查询采购商品信息 **/
	    getProductList() {
	    	if(this.selectproduct==true) {
	    		this.productquery.p=1;
	    		this.productquery.rollpage=10;
	    	}
	    
	    	this.productquery.supplierid=this.create.supplierid;
	    	this.addListLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.save(this.productquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.addListLoading=false;
		        }else{
		            this.productlists=JSON.parse(Base64.decode(res.data.Data));
		            this.product_order_rows=parseInt(res.data.count);
		            this.addListLoading=false;
		            if(this.selectproduct==true) this.selectproduct=false;
		            this.defaultselectgoods(); //获取已勾选的商品信息
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	            this.addListLoading=false;
	        });
	    },
	    
	    productPageSizeChange(val) {
	        this.productquery.rollpage = val;
	        this.getProductList();
	    },
	    productPageCurrentChange(val) {
	        this.productquery.p = val;
	        this.getProductList();
	    },
	    
	    /** 默认勾选已选择的商品信息 **/
	    defaultselectgoods() {
	    	var _this=this;	    	
	    	setTimeout(function() {
				_this.productlists.forEach(function(e,i) {
		    		if(_this.selectproductids.indexOf(e.id) >= 0) _this.$refs.multipleTable.toggleRowSelection(e);
	    		})
    		},100);
	    },
	    
	    //条形码搜索商品（按钮查询）
	    searchgoodsfrombutton() {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
	    
	    	//重置搜索条件
	    	this.productquery.brandid='';
	    	this.productquery.catid=[];
	    	this.productquery.supplierid=this.create.supplierid;
	    	this.productquery.key=this.codekey;
	    	this.productquery.p=1;
	    	this.productquery.rollpage=10;
	    	this.selectproductids=[];
	    	this.codekey='';
	    	
	    	this.addgoodsDialog=true;
		    this.getProductList();	     
	    },
	    
	    /** 添加采购商品 **/
	    addproducts() {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
	    	
	    	//重置搜索条件
	    	this.productquery.brandid='';
	    	this.productquery.catid=[];
	    	this.productquery.supplierid=this.create.supplierid;
	    	this.productquery.key='';
	    	this.productquery.p=1;
	    	this.productquery.rollpage=10;
	    	
	    	this.addgoodsDialog=true;
	    	this.selectproductids=[];
	    	this.getProductList();
	    },
	    
	    
	    /** 清空已选中的采购商品 **/ 
	    clearselectgoods() {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
	    	this.$confirm('您是否确定删除采购商品里所有商品的信息？', '提示', { type: 'warning' }).then(() => {
        		// 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'cleargoods',type:this.create.type,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('删除采购商品信息成功！');
	                    this.getsingleorder(this.create.type);
	                }
	            }).catch((res) => {
	            	
	            });
	        }).catch(() => {
	            
	        });
	    },
	    
	    /** 启用/停止排序 **/
	    startandstopsort() {
	    	if(this.sorttable==true) {
	    		this.sorttable=false;
	    		this.sorttype='';
	    		this.sorticon='el-icon-circle-close-outline';
	    		this.sortname='停止排序';  
	    	}else {
	    		this.sorttable=true;
	    		this.sorttype='warning';
	    		this.sorticon='el-icon-circle-check-outline';
	    		this.sortname='启用排序';
	    		var result=[];
	    		var count=this.listsorts.length;
	    		this.listsorts.forEach(function(e,index) {
	    			count--;
	    			result.push({id:e.id,sort:count});
	    		});
	    		
	    		var resource = this.$resource(this.url);
	            resource.save({ act:'changesort',token:this.$cookies.get('token'),sortlists:result}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('删除采购商品信息成功！');
	                    this.getsingleorder(this.create.type);
	                }
	            }).catch((res) => {
	            	
	            });	 
	    	}
	    },
	    
	    totalRule() {
	    	var _this=this;
	    	var price=0;
	    	var num=0;
			var sell=0;
	    	var total=0;	    		    	
	    	this.create.goods.forEach(function(e,index) {
			    price += parseFloat(e.price);
				sell += parseFloat(e.sell);
			    num += parseInt(e.num);
			    total += parseFloat(e.total);
		    });
		    price=price.toFixed(2);
		    total=total.toFixed(2);
		    return ['合计','','','','','',num,total,''];
	    },
	    
	    /** 删除订单商品信息 **/
	    delgoods(id) {
	    	this.$confirm('您是否需要删除该商品信息？', '提示', { type: 'warning' }).then(() => {
        		// 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'delgoods',id:id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('删除商品信息成功！');
	                    this.getsingleorder(this.create.type);
	                }
	            }).catch((res) => {
	            	
	            });
	        }).catch(() => {
	            
	        });
	    }, 
	    
	    /** 获取单位信息 **/
	    getUnitlists(productid,id,unitid) {
	    	this.changegoodsid=id;
			this.changeunitid=unitid;
	    	// 向请求服务端删除
	    	this.unitDialog=true;
	    	this.unitListLoading=true;
	        var resource = this.$resource(this.url);
	        resource.save({ act:'getunitlists',id:productid,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.unitListLoading=false;
	            }else{
	                this.unitlists=JSON.parse(Base64.decode(res.data.Data));
	                this.unitListLoading=false;
	            }
	        }).catch((res) => {
	            this.unitListLoading=false;	
	        });
	    },
	    
	    /** 保存商品单位信息 **/
	    saveunitid(unitid) {
	        var resource = this.$resource(this.url);
	        resource.save({ act:'saveunitid',id:this.changegoodsid,unitid:unitid,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	            	this.unitDialog=false;
	            	this.$message.success('修改商品单位信息成功！');
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },

		//修改商品单价
		setgoodsprice(id,price) {
			var resource = this.$resource(this.url);
	        resource.save({ act:'setprice',id:id,price:price,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
		},

		//修改商品折扣
		setgoodsdiscount(id,discount) {
			var resource = this.$resource(this.url);
	        resource.save({ act:'setdiscount',id:id,discount:discount,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
		},
	    
	    /** 修改商品金额 **/
	    setgoodssell(id,sell) {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setsell',id:id,sell:sell,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 修改数量信息 **/
	    setgoodsnum(id,num) {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setnums',id:id,num:num,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 小改商品小计 **/
	    setgoodstotal(id,total) {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'settotal',id:id,total:total,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 复制订单商品信息 **/
	    copygoods(id) {
	    	this.$confirm('您是否需要对该商品信息进行复制？', '提示', { type: 'warning' }).then(() => {
        		// 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'copygoods',id:id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('商品信息复制成功！');
	                    this.getsingleorder(this.create.type);
	                }
	            }).catch((res) => {
	            	
	            });
	        }).catch(() => {
	            
	        });
	    },
	    
	    /** 设置优惠金额 **/
	    setderate() {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setderate',type:this.create.type,derate:this.create.derate,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 设置应付金额 **/ 
	    setdeal() {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setdeal',type:this.create.type,deal:this.create.deals,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 修改采购人信息 **/ 
	    setseller() {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setseller',type:this.create.type,clerkid:this.create.clerkid,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 设置备注信息 **/ 
	    setdesc() {
	    	var resource = this.$resource(this.url);
	        resource.save({ act:'setdesc',type:this.create.type,desc:this.create.desc,token:this.$cookies.get('token')}).then((res) => {
	        	if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.getsingleorder(this.create.type);
	            }else{
	                this.getsingleorder(this.create.type);
	            }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    /** 保存订单信息 **/ 
	    saveorder() {
	    	this.saveorderLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.save(this.create).then((res) => {
	            if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.saveorderLoading=false;
	            }else{
	                this.$message.success('保存采购订单信息成功！');
	                this.saveorderLoading=false;
	                
	                this.create.id=0;
			        this.create.documents='';
			        this.create.total=0.00;
			        this.create.derate=0.00;
			        this.create.deal=0.00;
			        this.create.managerid='';
			        this.create.supplierid='';
			        this.create.desc='';
			        this.create.status=0;
			        this.create.isdraft=1;
			        this.create.goods=[];	        	
			    	this.addDialog=true;
			    	this.selectproductids=[];
			    	this.create.clerkid='';
					this.create.warehouse_id=''
			    	
			    	this.sorttable=true;
			    	this.sorttype='warning';
			    	this.sorticon='el-icon-circle-check-outline';
			    	this.sortname='启用排序';
			    	this.getsingleorder(1);
	            }
	        }).catch((res) => {
	        	this.saveorderLoading=false;	
	        });
	    }, 
	    
	    /** 审核订单信息 **/
	    verifyorder(isprint) {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
			this.verifyorderLoading=true;
			var resource = this.$resource(this.url);
			resource.save({act:'verifyorder',token:this.$cookies.get('token'),id:0,type:this.create.type,clerkid:this.create.clerkid,warehouse_id:this.create.warehouse_id}).then((res) => {
				if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.verifyorderLoading=false;
			    }else{
			        this.$message.success("保存采购订单信息成功！");
			        var result=JSON.parse(Base64.decode(res.data.Data));
			        this.printorderid=result.id;
			        this.verifyorderLoading=false;
			        
			        this.create.id=0;
			        this.create.documents='';
			        this.create.total=0.00;
			        this.create.derate=0.00;
			        this.create.deal=0.00;
			        this.create.managerid='';
			        this.create.supplierid='';
			        this.create.desc='';
			        this.create.status=0;
			        this.create.isdraft=1;
			        this.create.goods=[];	        	
			    	this.addDialog=true;
			    	this.selectproductids=[];
			    	this.create.clerkid='';
					this.create.warehouse_id=''
			    	
			    	this.sorttable=true;
			    	this.sorttype='warning';
			    	this.sorticon='el-icon-circle-check-outline';
			    	this.sortname='启用排序';
			    	this.getsingleorder(1);	

					if(isprint==true) {
						this.verifyandprintLoading=false;
		    			this.getprintorder(this.printorderid); //获取订单打印信息
					}

			    }
			}).catch((res) => {
			    this.delorderLoading=false;
			});
	    },   
	    
	    /** 审核并打印订单信息 **/
	    verifyandprintorder() {
	    	if(this.sorttable==false) {this.$message.error('请选停止排序');return false;}
		    this.verifyandprintLoading=true;

			this.isprint=true;
		    this.verifyorder(true); //审核信息
	    },
	    
	    //获取打印订单信息
	    getprintorder(id) {
			this.printLoading=true;
			this.printerDialog=true;
			this.printlists=[];
			var resource = this.$resource(this.url);
		    resource.save({act:'getprintinfos',token:this.$cookies.get('token'),id:id,rollpage:this.rollpage}).then((res) => {
		    	if(res.data.Result>0){
		        	if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.printLoading=false;
		        }else{
		            this.printLoading=false;
		            this.printlists=JSON.parse(Base64.decode(res.data.Data));
		            this.orderstatus=this.printlists[0].status;
		        }
		    }).catch((res) => {
		    	this.printLoading=false;
		    });    
	    },
	    
	    //修改订单打印每页展示条数
	    changepagevlaue(id) {
	    	this.getprintorder(id);
	    },
	    
	    //商品拖拽排序
	    getdata(evt){
	    	console.log(evt.draggedContext.element.id);
	    },
	    datadragEnd(evt){
	    	console.log('拖动前的索引：'+evt.oldIndex);
	        console.log('拖动后的索引：'+evt.newIndex);                
	    },
	    
	    /** 点击单行选择/取消选中商品  **/
	    rowclick(val,row) {
	    	this.nowtime ++;
	    	if(this.timeoutflag==false) return false;
	    	
	    	var _this=this;
	    	this.timeoutflag=false;
	    	setTimeout(function() {
	    		if(_this.nowtime==1) { //单击事件
	    			_this.selectrow(val,row);
	    		}else { //双击事件
	    			_this.selectsingle(val,row);
	    		}
	    		_this.nowtime=0;
	    		_this.timeoutflag=true;
	    	},250);
	    },
	    
	    /** 单击商品 **/
	    selectrow(val,row) {
	    	var _this=this;
	    	var id=val.id;
	    	var status=-1;
	    	this.selectproductids.indexOf(id) >= 0 ? this.selectproductids.splice(this.selectproductids.indexOf(id),1) : this.selectproductids.push(id);
	    	this.productlists.forEach(function(e,index) {e.id==id ? status=index : ''});
	    	if(status >= 0) this.$refs.multipleTable.toggleRowSelection(this.productlists[status]);
	    },
	    
	    /** 双击选择商品 **/
	    selectsingle(val,row) {
	    	this.selectproductids=[];
	    	//添加商品进入购物车
	    },
	    
	    /** 单选商品信息 **/
	    handleSelectsingle(val,row) {
	    	var _this=this;
	    	var id=row.id;
	    	this.selectproductids.indexOf(id) >= 0 ? this.selectproductids.splice(this.selectproductids.indexOf(id),1) : this.selectproductids.push(id);
	    },
	    
	    /** 全选/全不选添加商品信息 **/
	    handleSelectionChange(val,row) {
	    	var _this=this;
	    	var pstatus=0;
	    	var status=0;
	    	var nowproductids=[];
	    	if(this.selectproductids.length==0) {
	    		val.forEach(function(e,index) {_this.selectproductids.push(e.id)});
	    		return false;
	    	}
	    	
	    	//获取当前列表信息状态
	    	this.productlists.forEach(function(e,index) {nowproductids.push({id:e.id,status:false})});
	    	nowproductids.forEach(function(e,i) {
	    	    pstatus=0;
	    		val.forEach(function(ee,ii) {
	    			if(e.id==ee.id) pstatus=1;
	    		});
	    		pstatus==1 ? nowproductids[i].status=true : '';
	    	});
	    	
	    	nowproductids.forEach(function(e,i) {
	    		if(e.status==true && _this.selectproductids.indexOf(e.id) < 0) _this.selectproductids.push(e.id);
	    		if(e.status==false && _this.selectproductids.indexOf(e.id) >= 0) _this.selectproductids.splice(_this.selectproductids.indexOf(e.id),1);
	    	});
	    },
	    
	    /** 添加商品进入购物车 **/
	    addgoods() {
	    	if(this.selectproductids.length==0) {this.$message.error('请添加需要采购的商品');return false;}	    
	    	var resource = this.$resource(this.url);
	        resource.save({act:'addinventory',token:this.$cookies.get('token'),type:this.create.type,goodsids:this.selectproductids}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.$message.success('添加商品信息成功');
		            this.addgoodsDialog=false;
		            this.getsingleorder(this.create.type);
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    /** 获取打印模板设置 **/
	    getprintsmodel() {
	    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	        resource.query({ act:'getmodelsetting',id:6,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
		            this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
		        }
	        }).catch((res) => {
	            
	        });
	    },
	    
	    //打印订单
	    createnoSave() {
	    	var id=this.printlists[0].id;
	    	this.printorderLoading=true;
	    	var resource = this.$resource(this.url);
		    resource.save({act:'changeprintnumber',token:this.$cookies.get('token'),id:id}).then((res) => {
		    	if(res.data.Result>0){
		        	if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.printorderLoading=false;
		        }else{
		            this.printorderLoading=false;
		            this.printlocalpage(); //打印 
		        }
		    }).catch((res) => {
		    	this.printorderLoading=false;
		    });
	    },
	    
	    /** 打印当前页面 **/
	    printlocalpage() {
	    	//设置打印完成后回调页面
	    	this.$cookies.set('returnurlids','143,144');
	    	//设置打印信息
	    	var div_print=document.getElementById('printContent');
		    var newStr=div_print.innerHTML;
		    var oldStr=document.body.innerHTML;
		    document.body.innerHTML=newStr;
		    window.print();
		    document.body.innerHTML=oldStr;	    
		    location.reload();
	    },
        /** 获取仓库 **/
		getWarehouse(){
			var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
			resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
			});
		},
	     
    }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.titlelists {float:left;width:100%;padding:0;margin:0}
.titlelists li {float:left;width:33.3%;font-size:15px;list-style-type:none}
.top1 td {padding-top:2px;font-size:15px}
.top2 td {padding-top:2px;font-size:15px;}
.top1 td span {font-size:15px}
.top2 td span {font-size:15px}
.sureprint {float:right;margin-right:15.5%}

.purchase-goods-id {display:inline-block;width:100%;font-size:13px;color:#666666}
.purchase-goods-number {display:inline-block;width:100%;font-size:12px;color:#777777}
.purchase-goods-infos {float:left;width:60px;height:60px;display:flex;justify-content:center;align-items:center;border-radius:6px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3)}
.purchase-goods-infos img {max-width:85%;max-height:85%;border-radius:6px}
.purchase-goods-infos-content {float:left;margin-left:2%;width:calc(100% - 2% - 62px);height:62px;overflow:hidden;}
.purchase-goods-infos-content-name {float:left;width:100%;font-size:13px;line-height:21px;color:#666666;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.purchase-goods-infos-content-spec {float:left;width:100%;font-size:12px;line-height:21px;color:#777777;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.purchase-goods-infos-content-code {float:left;width:100%;font-size:12px;line-height:21px;color:#777777;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}


.cz-sell-base-lists-infos-out {display:inline-block;width:100%;}
.cz-sell-base-lists-infos {float:left;display:flex;justify-content:left;align-items:center;font-size:0;width:25%;height:50px;overflow:hidden;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {float:left;text-align:right;font-size:13px;line-height:23px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {float:left;margin-left:10px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {text-align:left;width:220px;border-bottom:1px solid #dcdfe6;border-top:none;border-left:none;border-right:none;border-radius:0;height:40px;line-height:40px;font-size:13px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {box-shadow:none;border-bottom:1px solid #dcdfe6;}
.cz-sell-base-lists-infos .el-input.is-active .el-input__inner, .cz-sell-base-lists-infos .el-input__inner:focus {border-color:#dcdfe6 !important;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {margin-top:7px}

.cz-sell-base-lists-infos-goods {display:inline-block;width:100%;margin-top:20px;}
.cz-sell-base-lists-infos-goods .el-table {font-size:13px;}
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {background:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table td, .cz-sell-base-lists-infos-goods .el-table th.is-leaf {border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,.cz-sell-base-lists-infos-goods .el-table .hover-row > td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {background:#E4E7ED;border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-input__inner {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:none;border-top:none;border-left:none;border-right:none;border-radius:15px;height:32px;line-height:32px;font-size:13px;}
.cz-sell-base-lists-infos-goods .el-input__inner:hover {box-shadow:none;border:none;}
.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td, .cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {background-color:#E4E7ED;}
.cz-table-refund-num-style1 .el-input__inner {border:1px solid #dcdfe6;border-radius:15px 0 0 15px;}

.cz-sell-order-stat {width:calc(100%);height:100px;position:relative;margin-top:10px;margin-bottom:20px;background:none;display:flex;justify-content:center;align-items:center;}
.cz-sell-order-stat-handles {padding:10px 20px;height:60px;border-left:1px solid #EBEEF5;width:30%;display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals {padding:10px 20px;height:100px;width:calc(100% - 30% - 40px - 40px - 1px);display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals-name {float:left;width:calc(25% - 30px) !important;padding:3px 30px 0 0 !important;font-size:13px;}
.cz-sell-order-stat-totals-name-title {float:left;width:80px;}
.cz-sell-order-stat-totals-name-content {float:left;width:calc(100% - 100px - 10px - 30px);padding:0 15px;color:red;font-weight:550;font-size:14px;}

.cz-sell-order-stat-totals-name .el-input {width:calc(100% - 80px - 5px);font-size:14px;}
.cz-sell-order-stat-totals-name .el-input__inner {color:red;font-weight:550;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:1px solid #c0c4cc !important;border-top:none;border-left:none;border-right:none;border-radius:0;height:32px;line-height:32px;font-size:13px;background:none;text-align:left;}
.cz-sell-order-stat-totals-name .el-input__inner:hover {box-shadow:none;border:none;border-bottom:1px solid #c0c4cc !important;background:none;}
.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner, .cz-sell-order-stat-totals-name .el-input__inner:focus {border-color:#c0c4cc !important;background:none;}



@media print{
  .pageBreak{page-break-after: always;}
  .noPrint{display: none;}
}
</style>


// WEBPACK FOOTER //
// src/components/purchase/orderadd.vue